import type { FilterObject } from '@moment/trading-types/filter-expression'

import { toError } from '@moment/observability/logger'

import { createLogger } from '@/lib/logger'

const LOGGER = createLogger('utils/decode-filters')

export function decodeFilter(
  encodedFilter: string | null,
): FilterObject | null {
  if (!encodedFilter) return null
  try {
    return JSON.parse(decodeURIComponent(encodedFilter)) as FilterObject
  } catch (error) {
    LOGGER.error('Error decoding filter', { error: toError(error) })
    return null
  }
}
